
import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { ReportageSection } from './components/ReportageSection';
import { DataSection } from './components/DataSection';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main role="main">
        <HeroSection />
        <ReportageSection />
        <DataSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
